module.exports = __webpack_public_path__ + "img/seat-logo.ae23c113.svg";